// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "b3294e784c908f861f2aee0ae3142672ae90cca7/static/css/" + chunkId + "." + "9ae35b6f" + ".chunk.css";
};